import { UseFormReturn, FieldValues } from 'react-hook-form'
import { Design } from '../../../../api/Designs/Types'

export type CalculatorData = Partial<ManualProcessDetails & EquipmentAutomationDetails>

export type CalculatorDataAsNumbers = {
  [x in keyof CalculatorData]: number
}

export interface DesignData {
  designNumber: string | number
}

interface ManualProcessDetails {
  hoursPerShift: string | number
  shiftsPerDay: string | number
  numberOfWorkersPerShift: string | number
  workDaysPerWeek: string | number
  labourRate: string | number
  estimatedWorkerEfficiency: string | number
  manualProcess: string | number
}

interface EquipmentAutomationDetails {
  equipmentHardwareCost: string | number
  estimatedEquipmentEfficiency: string | number
  automatedProcess: string | number
}

export enum StepName {
  one = 'manual-process-details',
  two = 'equipment-automation-details',
  summary = 'summary',
}

export interface StepProps {
  formControl: UseFormReturn<FieldValues>
  watchedFields?: {
    [x in keyof CalculatorData]: string | number
  }
  exchangeRate: ExchangeRate
  design?: Design
}
